// @import types
import { IHttpResponse } from 'app_types/httpTypes'
// @end

// @add your types
export enum CourseFormationType {
  COURSE = 'course',
  PROGRAM = 'program',
  DIPLOMA = 'diploma'
}

export interface INewCourse {
  name: string,             // Nombre del curso
  fullname: string,         // Nombre Completo del curso
  displayname: string,      // Nombre Para mostrar del curso
  description: string,      // Descripción del curso
  courseType?: string,      // Tipo de curso
  mode?: string,            // Modalidad
  startDate: string,        // fecha de inicio
  endDate: string,          // fecha de finalización
  maxEnrollmentDate: string,// Fecha mxima de inscripción.
  priceCOP: number,         // Precio en Pesos Colombianos
  priceUSD: number,         // Precio en Dólares Estadounidenses
  discount: number,         // Porcentaje de descuento del precio
  quota: number,            // cantidad máxima de cupos
  lang: string,             // Idioma en el que se da el curso
  slug?: string
  formationType?: CourseFormationType
}

 export interface ICourseListItem extends INewCourse {
  _id: string
}

export interface ICoursesHttpResponse extends IHttpResponse {
  courses: ICourseListItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}

export interface ICourseHttpResponse extends IHttpResponse {
  course: INewCourse
  total_register: number
  pageNumber: number
  nPerPage: number
}
//@end
